<app-loading *ngIf="contentReady"></app-loading>
<div class="container-fluid p-0">
    <div>


        <div class="col-12 col-sm-12 main-content">
            <div class="container-fluid mb-4">
                <div class="categoryContainer">

                      <div class="col-12">
                        <button routerLink="/createcomplex" style="margin-left: 0;" class="first-btn btn btn-primary">
                            {{ 'complex' | translate }}
                        </button>
                        <!-- <button (click)="exportToExcel()" class="btn first-btn btn-primary">
                            {{ "export to excel" | translate }}
                        </button> -->

                        <button (click)="getAllClients(10, 1)" style="margin-left: 0;"
                            class="first-btn btn btn-primary">
                            {{ 'refresh' | translate }}
                        </button>
                        <div class="input-group mb-3">
                            <input type="text" class="form-control" [(ngModel)]="searchKey"
                                placeholder="{{ 'searchwithname' | translate }}" aria-label="Recipient's username"
                                aria-describedby="basic-addon2">
                            <div class="input-group-append">
                                <button class="btn btn-outline-secondary" (click)="search()" type="button">{{ 'Search' |
                                    translate
                                    }}</button>
                            </div>
                        </div>



                    </div>
                </div>
                <div>
                    <table mat-table id="Clients" [dataSource]="dataSource" class="mat-elevation-z8">

                        <ng-container matColumnDef="complex_name">
                            <th mat-header-cell *matHeaderCellDef>{{ 'complex_name' | translate }}</th>
                            <td mat-cell *matCellDef="let el">{{ el.complex_name }}

                            </td>
                        </ng-container>

                        <ng-container matColumnDef="complex_location">
                            <th mat-header-cell *matHeaderCellDef>{{ 'complex_location' | translate }}</th>
                            <td mat-cell *matCellDef="let el">{{ el.complex_location }}
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="request_details">
                            <th mat-header-cell *matHeaderCellDef>{{ 'request_details' | translate }}</th>
                            <td mat-cell *matCellDef="let el">{{ el.request_details }}</td>
                        </ng-container>


                <ng-container matColumnDef="add_by">
              <th mat-header-cell *matHeaderCellDef>أضيف بواسطة</th>
              <td mat-cell *matCellDef="let el">{{ el.add_by }}

                <br>
                {{formatDate(el.created_at)}}
              </td>
            </ng-container>




                        <ng-container matColumnDef="notes">
                            <th mat-header-cell *matHeaderCellDef>{{ 'note' | translate }}</th>
                            <td mat-cell *matCellDef="let el">{{ el.notes }}</td>
                        </ng-container>
                        <ng-container matColumnDef="status">
                            <th mat-header-cell *matHeaderCellDef>{{ 'status' | translate }}</th>
                            <td mat-cell *matCellDef="let el">
                                @if(el.status == 0){
                                <span style="color: orange; font-size: 14px;">{{ 'Under procedure' | translate }}</span>
                                }
                                @else if(el.status == 1){
                                <span style="color: red; font-size: 14px;">ملغي</span>
                                }
                                @else if(el.status == 2){
                                <span style="color: blue; font-size: 14px;">جاري التوريد</span>
                                }
                                @else {
                                <span style="color: green; font-size: 14px;"> مكتمل </span>
                                }

                            </td>
                        </ng-container>


                        <ng-container matColumnDef="options">
                            <th mat-header-cell *matHeaderCellDef> </th>
                            <td mat-cell *matCellDef="let element">

                                <div class="dropdown">
                                    <button class="btn btn-secondary dropdown-toggle" type="button"
                                        id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                                        <i class="fa-solid fa-ellipsis-vertical"></i>
                                    </button>
                                    <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">

                                        <li><a class="dropdown-item" *ngIf='element.status !== 0'
                                                (click)='changeComplex(element.id, 0)'>{{ 'Under procedure' |
                                                translate }}</a></li>
                                        <li><a class="dropdown-item" *ngIf='element.status !== 1'
                                                (click)='changeComplex(element.id, 1)'>ملغي</a></li>
                                        <li><a class="dropdown-item" *ngIf='element.status !== 2'
                                                (click)='changeComplex(element.id, 2)'>جاري التوريد</a></li>
                                        <li><a class="dropdown-item" *ngIf='element.status !== 3'
                                                (click)='changeComplex(element.id, 3)'>مكتمل</a></li>
                                        <li><a class="dropdown-item" (click)='edit(element)'>
                                                {{ "Edit" | translate }} </a></li>

        @if(isAdmin){
                                        <li><a class="dropdown-item" (click)='delete(element.id)'>{{ "Delete" |
                                                translate }}</a></li>
                                        }
                                    </ul>
                                </div>
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                    </table>

                    <mat-paginator
                        style="margin-top: 20px; background: #f5f5f5; border: 1px solid #ddd; border-radius: 6px; padding: 10px;"
                        [length]="totalItems" [pageSize]="10" (page)="onPaginateChange($event)">
                    </mat-paginator>

                </div>

                <div class="row">
                    @if (noData) {
                    <app-nodata></app-nodata>
                    }
                </div>
            </div>
        </div>
    </div>
</div>